import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DevelopmentAppraisalDataList } from "../../Types/Project/DefaultModels/DevelopmentAppraisal/DevelopmentAppraisalDataList";
import { getAllDevelopmentAppraisalList } from "../../Thunks/DevelopmentAppraisalThunks";

interface DevelopmentAppraisalStateSlice {
    loader: boolean; // for refres pages and inital loadings
    developmentAppraisalList: DevelopmentAppraisalDataList [];
    errorDisplay: string | null;
}

// set inital valus
const initialState : DevelopmentAppraisalStateSlice = {
    loader: false,
    developmentAppraisalList: [],
    errorDisplay: '',

}

// set state valu for api response
const developmentAppraisalSlice = createSlice ({
    name: 'developmentAppraisalSlice',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getAllDevelopmentAppraisalList.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getAllDevelopmentAppraisalList.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getAllDevelopmentAppraisalList.fulfilled, (state, action: PayloadAction<DevelopmentAppraisalDataList[]>) => {
                    state.loader = false;
                    state.developmentAppraisalList = action.payload;
                  })
    }
})

export const {} = developmentAppraisalSlice.actions
export default developmentAppraisalSlice.reducer
